import banner2 from "../assets/banner2.jpg";
import UnifiedServicePage from "./UnifiedServicePage";

export default function ProjectsTrackRecordPage() {
  return (
    <UnifiedServicePage
      title="Projects & Track Record"
      kicker="Proven Delivery Across Sectors"
      intro="We have delivered successful energy, electrical, and security projects for corporate companies, institutions, government entities, and individual clients."
      heroImage={banner2}
      overviewTitle="Execution You Can Trust"
      overviewText="Our portfolio demonstrates consistent quality in planning, installation, commissioning, and post-deployment support."
      featureTitle="Portfolio Areas"
      features={[
        {
          title: "Battery Backup Systems",
          desc: "Installation and support of reliable backup power systems for financial institutions and enterprises.",
        },
        {
          title: "Solar Surveillance Power",
          desc: "Supply, installation, and commissioning of solar systems for remote surveillance stations.",
        },
        {
          title: "Electrical & CCTV Works",
          desc: "Integrated electrical and security installations for commercial and residential properties.",
        },
        {
          title: "Maintenance & Repairs",
          desc: "Preventive and corrective maintenance for AC systems and industrial support equipment.",
        },
        {
          title: "Solar Water Pumping",
          desc: "Deployment of water pumping systems backed by technical support and training.",
        },
        {
          title: "Client-Centered Support",
          desc: "Strong coordination with institutions, government clients, and private organizations.",
        },
      ]}
      focusTitle="Selected Client Segments"
      focusItems={[
        {
          title: "Banking Institutions",
          desc: "Projects delivered for major banking clients including backup and security systems.",
        },
        {
          title: "Government Facilities",
          desc: "Surveillance and infrastructure support projects in regional and remote locations.",
        },
        {
          title: "Commercial Properties",
          desc: "Electrical and CCTV implementations in business and residential complexes.",
        },
        {
          title: "Industrial Operations",
          desc: "Maintenance and technical services for operational continuity and safety.",
        },
      ]}
      testimonyQuote="DOUBLE F has consistently delivered quality projects from design to installation and after-sales service."
      testimonyAuthor="Spokesperson, BOA"
      ctaTitle="Planning a Similar Project?"
      ctaText="Share your requirements and we will propose a practical implementation plan."
    />
  );
}
